const EditIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="icon-edit"
  >
    <g id="Vector">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4101 5.69228L10.8416 2.13497L12.2148 0.776032C12.4012 0.598879 12.649 0.5 12.9065 0.5C13.1641 0.5 13.4117 0.598879 13.5981 0.776032L15.7231 2.89439C15.9008 3.08023 16 3.32706 16 3.5838C16 3.84055 15.9008 4.0875 15.7231 4.27333L14.4101 5.69228Z"
        fill="#0466B4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.23608 15.8244L0.427169 16.4939C0.369534 16.5046 0.31004 16.5012 0.254032 16.4839C0.198023 16.4666 0.147193 16.4359 0.105733 16.3946C0.0642733 16.3533 0.0335123 16.3026 0.0161664 16.2468C-0.00117957 16.1909 -0.00463679 16.1316 0.00613294 16.0742L0.67776 12.2772L4.23608 15.8244Z"
        fill="#0466B4"
      />
      <path
        d="M9.83508 2.97178L1.6969 11.0817L5.25436 14.6293L13.3925 6.51935L9.83508 2.97178Z"
        fill="#0466B4"
      />
    </g>
  </svg>
);

export default EditIcon;
